<div class="container py-7 text-center">
    <a routerLink="/">
        <img src="../../assets/img/logo.svg" class="logo img-fluid" />
    </a>
    <h1 class="text-center py-5">Page non trouvée</h1>
    <a routerLink="/" class="d-inline-block mt-5">Retour à l'application</a>
</div>
